import { render } from "./GroupNew.vue?vue&type=template&id=57b52598"
import script from "./GroupNew.vue?vue&type=script&lang=js"
export * from "./GroupNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__